<section class="kr-table__column kr-transaction__date">
  {{ transaction().created | date: 'dd.MM.yy' }}

  <div class="kr-transaction__date-time">
    {{ transaction().created | date: 'HH:mm' }}
  </div>
</section>

<section class="kr-table__column">
  @if (transaction().fromWalletType) {
    <kr-provider-icon
      class="kr-transaction__icon"
      [providerType]="transaction().fromWalletType" />
  }
  <span class="kr-transaction__from">
    {{ transaction().fromWallet }}
  </span>

  <kr-copy-tooltip [text]="transaction().fromWallet" />
</section>

<section class="kr-table__column">
  <span class="kr-transaction__to">
    {{ transaction().toWallet }}
  </span>

  <kr-copy-tooltip [text]="transaction().toWallet" />
</section>

<section class="kr-table__column kr-transaction__hash">
  @if (transaction().tx) {
    <kr-copy-tooltip [text]="transaction().tx" iconName="hash" />
  }
</section>

<section class="kr-table__column">
  {{ 'dictionary.transactionTypes.' + transaction().trTypeString | translate }}
</section>

<section class="kr-table__column">
  @if (transaction().statusOriginal) {
    <kr-status
      [small]="isolated()"
      [type]="transaction().statusOriginal"
      i18nPrefix="dictionary.transactionStatuses" />
  }
</section>

<section class="kr-table__column">
  @if (transaction().warnings) {
    <kr-copy-tooltip iconName="failed" [text]="transaction().warnings" />
  }
</section>

@if (!isolated()) {
  <section class="kr-table__column">
    {{ transaction().coin?.displayName }}
  </section>
}

<section class="kr-table__column kr-transaction__comment">
  @if (depositTransaction && transaction().statusOriginal === 'completed') {
    <button
      class="kr-transaction__comment-btn"
      type="button"
      (click)="openCommentDialog($event)">
      <fu-icon [iconName]="transaction().comment ? 'message' : 'add'" />
    </button>
  }
</section>

@let coinDisplayName =
  transaction().coin?.secondaryCoin
    ? transaction().coin?.secondaryCoin?.displayName
    : transaction().coin?.displayName;

<section
  class="kr-table__column kr-transaction__amount"
  [title]="
    payoutTransaction
      ? (transaction().network_fee_amount | balanceFormat: coinDisplayName) +
        ' ' +
        coinDisplayName
      : ''
  ">
  @if (payoutTransaction) {
    {{ transaction().network_fee_amount | balanceFormat: coinDisplayName }}
    <span>{{ coinDisplayName }}</span>
  }
</section>

<section
  class="kr-table__column kr-transaction__amount"
  [title]="
    transaction().process_fee_amount
      | balanceFormat: transaction().coin?.displayName
  ">
  {{
    transaction().process_fee_amount
      | balanceFormat: transaction().coin?.displayName
  }}
</section>

<section
  class="kr-table__column kr-transaction__amount"
  [title]="
    transaction().amount
      | balanceFormat: transaction().coin?.displayName
      | withDigitGroups
  ">
  {{
    transaction().amount
      | balanceFormat: transaction().coin?.displayName
      | withDigitGroups
  }}
</section>
